import type { addressType } from '$lib/types/util';

export const ZERO_ADDRESS: addressType = '0x0000000000000000000000000000000000000000';
export const MARKET_ADDRESES: { [key: string]: addressType } = {
	sETHPERP: '0x2B3bb4c683BFc5239B029131EEf3B1d214478d93',
	sAVAXPERP: '0xc203A12F298CE73E44F7d45A4f59a43DBfFe204D',
	sDYDXPERP: '0x139F94E4f0e1101c1464a321CBA815c34d58B5D9',
	sBTCPERP: '0x59b007E9ea8F89b069c43F8f45834d30853e3699',
	sAPEPERP: '0x5B6BeB79E959Aac2659bEE60fE0D0885468BF886',
	sMATICPERP: '0x074B8F19fc91d6B2eb51143E1f186Ca0DDB88042',
	sARBPERP: '0x509072A5aE4a87AC89Fc8D64D94aDCb44Bd4b88e',
	sOPPERP: '0x442b69937a0daf9D46439a71567fABE6Cb69FBaf',
	sBNBPERP: '0x0940B0A96C5e1ba33AEE331a9f950Bb2a6F2Fb25',
	sSOLPERP: '0x0EA09D97b4084d859328ec4bF8eBCF9ecCA26F1D',
	sLINKPERP: '0x31A1659Ca00F617E86Dc765B6494Afe70a5A9c1A',
	sDOGEPERP: '0x98cCbC721cc05E28a125943D69039B39BE6A21e9',
	sUNIPERP: '0x4308427C463CAEAaB50FFf98a9deC569C31E4E87',
	sAAVEPERP: '0x5374761526175B59f1E583246E20639909E189cE',
	sGMXPERP: '0x33d4613639603c845e61A02cd3D2A78BE7d513dc',
	sATOMPERP: '0xbB16C7B3244DFA1a6BF83Fcce3EE4560837763CD',
	sNEARPERP: '0xC8fCd6fB4D15dD7C455373297dEF375a08942eCe',
	sADAPERP: '0xF9DD29D2Fd9B38Cd90E390C797F1B7E0523f43A9',
	sLDOPERP: '0xaa94C874b91ef16C8B56A1c5B2F34E39366bD484',
	sCRVPERP: '0xD5fBf7136B86021eF9d0BE5d798f948DcE9C0deA',
	sLTCPERP: '0xB25529266D9677E9171BEaf333a0deA506c5F99A',
	sSHIBPERP: '0x69F5F465a46f324Fb7bf3fD7c0D5c00f7165C7Ea',
	sFLOWPERP: '0x27665271210aCff4Fab08AD9Bb657E91866471F0',
	sAPTPERP: '0x9615B6BfFf240c44D3E33d0cd9A11f563a2e8D8B',
	sBCHPERP: '0x96690aAe7CB7c4A9b5Be5695E94d72827DeCC33f',
	sFTMPERP: '0xC18f85A6DD3Bcd0516a1CA08d3B1f0A4E191A2C4',
	sAXSPERP: '0x3a52b21816168dfe35bE99b7C5fc209f17a0aDb1',
	sFILPERP: '0x2C5E2148bF3409659967FE3684fd999A76171235',
	sPEPEPERP: '0x3D3f34416f60f77A0a6cC8e32abe45D32A7497cb',
	sSUIPERP: '0x09F9d7aaa6Bef9598c3b676c0E19C9786Aa566a8',
	sBLURPERP: '0xa1Ace9ce6862e865937939005b1a6c5aC938A11F',
	sXRPPERP: '0x6110DF298B411a46d6edce72f5CAca9Ad826C1De',
	sDOTPERP: '0x8B9B5f94aac2316f048025B3cBe442386E85984b',
	sFLOKIPERP: '0x5ed8D0946b59d015f5A60039922b870537d43689',
	sINJPERP: '0x852210F0616aC226A486ad3387DBF990e690116A',
	sTRXPERP: '0x031A448F59111000b96F016c37e9c71e57845096',
	sSTETHPERP: '0xD91Db82733987513286B81e7115091d96730b62A',
	sETCPERP: '0x4bF3C1Af0FaA689e3A808e6Ad7a8d89d07BB9EC7',
	sCOMPPERP: '0xb7059Ed9950f2D9fDc0155fC0D79e63d4441e806',
	sMKRPERP: '0xf7d9Bd13F877171f6C7f93F71bdf8e380335dc12',
	sXMRPERP: '0x2ea06E73083f1b3314Fa090eaE4a5F70eb058F2e',
	sYFIPERP: '0x6940e7C6125a177b052C662189bb27692E88E9Cb',
	sMAVPERP: '0x572F816F21F56D47e4c4fA577837bd3f58088676',
	sRPLPERP: '0xfAD0835dAD2985b25ddab17eace356237589E5C7',
	sETHBTCPERP: '0xD5FcCd43205CEF11FbaF9b38dF15ADbe1B186869',
	sWLDPERP: '0x77DA808032dCdd48077FA7c57afbF088713E09aD',
	sUSDTPERP: '0x1681212A0Edaf314496B489AB57cB3a5aD7a833f',
	sEOSPERP: '0x50a40d947726ac1373DC438e7aaDEde9b237564d',
	sRUNEPERP: '0xEAf0191bCa9DD417202cEf2B18B7515ABff1E196',
	sXLMPERP: '0xfbbBFA96Af2980aE4014d5D5A2eF14bD79B2a299',
	sALGOPERP: '0x96f2842007021a4C5f06Bcc72961701D66Ff8465',
	sCELOPERP: '0x2292865b2b6C837B7406E819200CE61c1c4F8d43',
	sSEIPERP: '0x66fc48720f09Ac386608FB65ede53Bb220D0D5Bc',
	sZECPERP: '0xf8aB6B9008f2290965426d3076bC9d2EA835575e',
	sKNCPERP: '0x152Da6a8F32F25B56A32ef5559d4A2A96D09148b',
	sZILPERP: '0x01a43786C2279dC417e7901d45B917afa51ceb9a',
	s1INCHPERP: '0xd5fAaa459e5B3c118fD85Fc0fD67f56310b1618D',
	sICPPERP: '0x105f7F2986A2414B4007958b836904100a53d1AD',
	sXTZPERP: '0xC645A757DD81C69641e010aDD2Da894b4b7Bc921',
	sSUSHIPERP: '0xdcCDa0cFBEE25B33Ff4Ccca64467E89512511bf6',
	sENJPERP: '0x88C8316E5CCCCE2E27e5BFcDAC99f1251246196a',
	sONEPERP: '0x86BbB4E38Ffa64F263E84A0820138c5d938BA86E',
	sFXSPERP: '0x2fD9a39ACF071Aa61f92F3D7A98332c68d6B6602',
	sBALPERP: '0x71f42cA320b3e9A8e4816e26De70c9b69eAf9d24',
	sPERPPERP: '0xaF2E4c337B038eaFA1dE23b44C163D0008e49EaD',
	sRNDRPERP: '0x91cc4a83d026e5171525aFCAEd020123A653c2C9',
	sUMAPERP: '0xb815Eb8D3a9dA3EdDD926225c0FBD3A566e8C749',
	sZRXPERP: '0x76BB1Edf0C55eC68f4C8C7fb3C076b811b1a9b9f',
	sSTETHETHPERP: '0x08388dC122A956887c2F736Aaec4A0Ce6f0536Ce',
	sTIAPERP: '0x35B0ed8473e7943d31Ee1eeeAd06C8767034Ce39',
	sBONKPERP: '0xB3422e49dB926f7C5F5d7DaF5F1069Abf1b7E894',
	sPYTHPERP: '0x296286ae0b5c066CBcFe46cc4Ffb375bCCAFE640',
	sIMXPERP: '0xBBd74c2c8c89D45B822e08fCe400F4DDE99e600b',
	sTRBPERP: '0xbdb26bfb6A229d7f254FAf1B2c744887ec5F1f31',
	sMEMEPERP: '0x48BeadAB5781aF9C4Fec27AC6c8E0F402F2Cc3D6',
	sANKRPERP: '0x90c9B9D7399323FfFe63819788EeD7Cde1e6A78C',
	sFETPERP: '0x4272b356e7E406Eeef15E47692f7f4dE86370634',
	sGRTPERP: '0x3f957DF3AB99ff502eE09071dd353bf4352BBEfE',
	sJTOPERP: '0xae90E9BB73b32505FB56a0F4Fd4eC8cf94BaB730',
	sORDIPERP: '0xE698CcC3cD4f2172a848094eA6D28D89d750C16f',
	sPENDLEPERP: '0xd4e9e0784C3cE4796f54F2EA0D337c7CFcCFD645',
	sSTRKPERP: '0x2F0F0865dFDD52AdefB583Ae824dDE7D60b76a3B',
	sCVXPERP: '0x2F0Fe4B621E7e54110446cE2df699004c6194636',
	sJUPPERP: '0xf9AE92bc49A5DD96AE5840eaAE75218016811c99',
};

export const SC_WALLET_INDEX: addressType = '0xb43c0899ECCf98BC7A0f3e2c2A211d6fc4f9b3fE';
export const SC_WALLET_ACCOUNT_RESOLVER: addressType = '0x4a0B3986cb7e23df85A64100BF222Cf69F9787Aa';
export const SC_WALLET_SYNHETIX_PERPS_V2: addressType =
	'0xccd718d6d2b410e4a3b1e3402f4e5db681a1f363';
export const SC_WALLET_BASIC: addressType = '0x86ea8030221bf025bb11fadaBb794dAAA7051ae1';
// tokens
export const SUSD: addressType = '0x8c6f28f2F1A3C87F0f938b96d27520d9751ec8d9';
export const SC_WALLET_SYNTHETIX_LIMIT_ORDERS: addressType =
	'0x4395104fC82654ddEaC3ECF01AB40a1814bFb2f4';
export const USDC_ADDRESS: addressType = '0x7F5c764cBc14f9669B88837ca1490cCa17c31607';
export const ETH_ADDRESS: addressType = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';
export const SC_WALLET_AAVE: addressType = `0x558c403A907D3B010C10e9aFCcF652A0B0D09338`;

export const SC_EXECUTION_BOTS_CONTRACTS: Array<`0x${string}`> = [
	'0xc1F7a43Db81e7DC4b3F4C6C2AcdCBdC17C41b0Dc',
	'0x7634E43aA3f446C8d9D5014d609355F728361075'
];

export const FX_NFT_CONTRACT_ADDRESS: addressType = '0x7fD2746f20F2EDD69f121f985620d3af84297aff';
